import { reduceMotion } from '../../../initial_state';
import ReducedMotion from './reduced_motion';
import Motion from 'react-motion/lib/Motion';

export default reduceMotion ? ReducedMotion : Motion;



// WEBPACK FOOTER //
// ./app/javascript/mastodon/features/ui/util/optional_motion.js